import {RemoveObjectAction} from './removeObjectAction';
import {Layer} from '../layer';


export class RemoveFromUiAction extends RemoveObjectAction {

}
